import { invokeEvent } from 'shared-base';

export const extractModifiers = (model: any) => {
  try {
    const output = JSON.parse(JSON.stringify(model));

    const { valuesModel } = output;
    output.modifiers = {};

    Object.keys(valuesModel ?? {}).forEach((key) => {
      if (key.startsWith('modifier')) {
        output.modifiers[key] = valuesModel[key];
        delete output.valuesModel[key];
      }
    });

    return output;
  } catch (err) {
    invokeEvent('sentry', { err });
    return model;
  }
};
